<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewLead"
            :searchFilters="searchFilters"
            :dropdownOptions="dropdownOptions"
            @handleDynamicOption="handleDynamicOption"
            @searchPage="searchLeads"
            @resetFilters="resetFilters"
            @importData="importLeads"
            @removeItem="removeLead"
            @removeSelectedItems="removeLeads"
            @printList="printCustomersList"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="leadsList"
            :actions="actions"
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="saveLead" @handleReset="handleReset"
            />
        </MovableModal>
        <MovableModal v-model:visible="transModalVisible" :title="title1" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader1" @showLoader="showModalLoader1" @hideLoader="hideModalLoader1"  @closeModal="closeModal1">
            <div class="px-3">
                <div class="basis-1/4 mr-8 relative">
                    <label for="">System SMS Templates:<em></em></label><br />
                    <SearchableDropdown
                        :options="templateArr"
                        :dropdownWidth="dropdownWidth"
                        @option-selected="handleSelectedTemplate"
                        @clearSearch="clearSelectedTemplate"                               
                    />
                </div>
                <div class="text-left mb-4">
                    <label for="">Message:</label><br />
                    <!-- <quill-editor :key="editorComponentKey" v-model:value="messageContent"></quill-editor> -->

                    <div class="flex">
                        <div class="basis-1/2 mb-4 mr-3">
                            <select v-model="selectedPlaceholder" class="bg-slate-50 rounded border border-gray-400 text-sm pl-2 pt-1 w-full">
                                <option value="" disabled>Select Placeholder</option>
                                <option v-for="placeholder in leadPlaceholders" :key="placeholder.value" :value="placeholder.value">
                                    {{ placeholder.label }}
                                </option>
                            </select>
                        </div>
                        <button @click="insertPlaceholder" :disabled="!selectedPlaceholder" class="w-24 h-8 rounded bg-green-400 text-sm mr-2  text-white px-2 py-0.5">Insert</button>
                    </div>

                    <textarea v-model="contentModel" ref="textareaRef" rows="8" cols="64" class="bg-slate-50 rounded border border-gray-400 text-sm pl-2 pt-2" placeholder="Type your content here..."></textarea>
                </div>
                <button @click="sendClientSMS" class="rounded bg-green-400 text-sm mr-2  text-white px-2 py-1.5"><i class="fa fa-check-circle text-xs mr-1.5" aria-hidden="true"></i>Send SMS</button>
            </div>
        </MovableModal>
        <MovableModal v-model:visible="emailModalVisible" :title="title2" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader1" @showLoader="showModalLoader1" @hideLoader="hideModalLoader1"  @closeModal="closeModal1">
            <div class="px-3">
                <div class="basis-1/4 mr-8 relative mb-4">
                    <label for="">System Email Templates:<em></em></label><br />
                    <SearchableDropdown
                        :options="emailTempArr"
                        :dropdownWidth="dropdownWidth"
                        @option-selected="handleSelectedEmailTemplate"
                        @clearSearch="clearSelectedEmailTemplate"                               
                    />
                </div>
                <button @click="sendClientEmail" class="rounded bg-green-400 text-sm mr-2  text-white px-2 py-1.5"><i class="fa fa-check-circle text-xs mr-1.5" aria-hidden="true"></i>Send Email</button>
            </div>
        </MovableModal>
        <MovableModal v-model:visible="oppModalVisible" :title="title3" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader3" @showLoader="showModalLoader3" @hideLoader="hideModalLoader3" @closeModal="closeModal3">
            <DynamicForm 
                :fields="formFields3" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="qualifyLead" @handleReset="handleReset"
            />
        </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import SearchableDropdown from "@/components/SearchableDropdown.vue";
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { quillEditor } from 'vue3-quill';
import { useTextareaEditor } from '@/composables/TextAreaEditor';
import Swal from 'sweetalert2';

export default{
    name: 'Leads',
    components:{
        PageComponent, MovableModal,DynamicForm,quillEditor,SearchableDropdown
    },
    setup(){
        const { contentModel,textareaRef,leadPlaceholders,selectedPlaceholder,insertPlaceholder,} = useTextareaEditor('');
        const templateArr = computed(() => store.state.Crm_SMS_Templates.templateArr);
        const emailTempArr = computed(() => store.state.Crm_Email_Templates.templateArr);
        const emailTempID = ref('');
        const dropdownWidth = ref("500px");
        const messageContent = ref('');
        const modal_loader1 = ref('none');
        const modal_loader3 = ref('none');
        const title1 = ref('SMS Lead(s)');
        const title2 = ref('Email Lead(s)');
        const title3 = ref('Qualify Lead');
        const transModalVisible = ref(false);
        const emailModalVisible = ref(false);
        const oppModalVisible = ref(false);
        const currComponentKey = ref(0);
        const agentComponentKey = ref(0);
        const chanComponentKey = ref(0);
        const leadID = ref('');
        const sourceID = ref(null);
        const agentID = ref(null);
        const channelID = ref(null);
        const store = useStore();     
        const toast = useToast();
        const loader = ref('none');
        const modal_loader = ref('none');
        const idField = 'lead_id';
        const addButtonLabel = ref('New Lead');
        const title = ref('Lead Details');
        const addingRight = ref('Adding Marketing Leads');
        const removingRight = ref('Deleting Marketing Leads');
        const rightsModule = ref('CRM');
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const leadsList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('150px');
        const modal_left = ref('400px');
        const modal_width = ref('60vw');
        const isEditing = computed(()=> store.state.Sales_Leads.isEditing);
        const selectedLead = computed(()=> store.state.Sales_Leads.selectedLead);
        const selectedSource = computed(()=> store.state.Sales_Leads.selectedSource);
        const selectedRep = computed(()=> store.state.Sales_Leads.selectedRep);
        const selectedChannel = computed(()=> store.state.Sales_Leads.selectedChannel);
        const sourceArray = computed(() => store.state.Lead_Sources.sourceArr);
        const agentArray = computed(() => store.state.Sales_Reps.agentArr);
        const channelArray = computed(() => store.state.Campaign_Channels.channelArr);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Name", key:"name"},
            {label: "Phone No", key:"phone_number"},
            {label: "Email", key: "email"},
            {label: "Designation", key:"designation"},
            {label: "Company", key:"company_name"},
            {label: "Address", key:"address"},
            {label: "Town", key:"town"},
            {label: "Status", key:"status", txtColor:"statusColor"},
            {label: "Rating", key:"rating", textColor:"textColor"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Lead', rightName: 'Editing Marketing Leads'},
            {name: 'send-sms', icon: 'fas fa-comment', title: 'Send SMS', rightName: 'Sending CRM SMS'},
            {name: 'send-email', icon: 'fas fa-envelope', title: 'Send Email', rightName: 'Sending CRM Emails'},
            {name: 'convert', icon: 'fa fa-sign-in', title: 'Qualify Lead', rightName: 'Converting Marketing Leads'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Lead', rightName: 'Deleting Marketing Leads'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const userID = computed(()=> store.state.userData.user_id);
        const phone_number_search = ref("");
        const lead_name_search = ref("");
        const email_search = ref("");
        const status_search = ref("");
        const rating_search = ref("");
        const searchFilters = ref([
            {type:'text', placeholder:"Name...", value: lead_name_search, width:48,},
            {type:'text', placeholder:"Phone No...", value: phone_number_search, width:32,},
            {type:'text', placeholder:"Email...", value: email_search, width:48,},
            {
                type:'dropdown', placeholder:"Status..", value: status_search, width:28,
                options: [{text:'New',value:'New'},{text:'Contacted',value:'Contacted'},{text:'Qualified',value:'Qualified'},{text:'Converted',value:'Converted'},{text:'Lost',value:'Lost'}]
            },
            {
                type:'dropdown', placeholder:"Rating..", value: rating_search, width:28,
                options: [{text:'Hot',value:'Hot'},{text:'Warm',value:'Warm'},{text:'Cold',value:'Cold'}]
            },

        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchLeadSources = async() =>{
            await store.dispatch('Lead_Sources/fetchLeadSources', {company:companyID.value})
        };
        const handleSelectedSource = async(option) =>{
            await store.dispatch('Lead_Sources/handleSelectedSource', option)
            sourceID.value = store.state.Lead_Sources.sourceID;
            if(selectedLead.value && selectedSource.value){
                selectedLead.value.lead_source.lead_source_id = sourceID.value;
            }
        }
        const clearSelectedSource = async() =>{
            await store.dispatch('Lead_Sources/updateState', {sourceID: ''});
            sourceID.value = store.state.Lead_Sources.sourceID;
            if(selectedLead.value && selectedSource.value){
                selectedLead.value.lead_source.lead_source_id = sourceID.value;
            }
        }
        const fetchCampaignChannels = async() =>{
            await store.dispatch('Campaign_Channels/fetchCampaignChannels', {company:companyID.value})
        };
        const handleSelectedChannel = async(option) =>{
            await store.dispatch('Campaign_Channels/handleSelectedChannel', option)
            channelID.value = store.state.Campaign_Channels.channelID;
            if(selectedLead.value && selectedChannel.value){
                selectedLead.value.campaign_source.campaign_channel_id = channelID.value;
            }
        }
        const clearSelectedChannel = async() =>{
            await store.dispatch('Campaign_Channels/updateState', {channelID: ''});
            channelID.value = store.state.Campaign_Channels.channelID;
            if(selectedLead.value && selectedChannel.value){
                selectedLead.value.campaign_source.campaign_channel_id = channelID.value;
            }
        }
        const fetchSalesAgents = async() =>{
            await store.dispatch('Sales_Reps/fetchSalesAgents', {company:companyID.value})
        };
        const handleSelectedAgent = async(option) =>{
            await store.dispatch('Sales_Reps/handleSelectedAgent', option)
            agentID.value = store.state.Sales_Reps.agentID;
            if(selectedLead.value && selectedRep.value){
                selectedLead.value.sales_rep.sales_rep_id = agentID.value;
            }
        }
        const clearSelectedAgent = async() =>{
            await store.dispatch('Sales_Reps/updateState', {agentID: ''});
            agentID.value = store.state.Sales_Reps.agentID;
        }
        const agentValue = computed(() => {
           return (selectedLead.value && selectedLead.value.sales_rep && !agentID.value) ? selectedLead.value.sales_rep.sales_rep_id : agentID.value;
        });
        const sourceValue = computed(() => {
           return (selectedLead.value && selectedLead.value.lead_source && !sourceID.value) ? selectedLead.value.lead_source.lead_source_id : sourceID.value;
        });
        const channelValue = computed(() => {
           return (selectedLead.value && selectedLead.value.campaign_source && !channelID.value) ? selectedLead.value.campaign_source.campaign_channel_id : channelID.value;
        });
        const formFields = ref([]);
        const updateFormFields = () => {
            formFields.value = [
                { type: 'text', name: 'full_name',label: "Name", value: selectedLead.value?.full_name || '', required: true },
                { type: 'text', name: 'phone_number',label: "Phone Number", value: selectedLead.value?.phone_number || '', required: true },
                { type: 'text', name: 'email',label: "Email", value: selectedLead.value?.email || '', required: true },
                { type: 'text', name: 'designation',label: "Designation", value: selectedLead.value?.designation || '', required: false },
                { type: 'text', name: 'company_name',label: "Company Name", value: selectedLead.value?.company_name || '', required: false },
                { type: 'text', name: 'address',label: "Address", value: selectedLead.value?.address || '', required: true },
                { type: 'text', name: 'town',label: "Town", value: selectedLead.value?.town || '', required: false },
                { type: 'text', name: 'country',label: "Country", value: selectedLead.value?.country || '', required: false },
                { type: 'dropdown', name: 'status',label: "Status", value: selectedLead.value?.status || 'New', required: true , options: [{text:'New',value:'New'},{text:'Contacted',value:'Contacted'},{text:'Qualified',value:'Qualified'},{text:'Converted',value:'Converted'},{text:'Lost',value:'Lost'}]},
                { type: 'dropdown', name: 'rating',label: "Rating", value: selectedLead.value?.rating || 'Warm', required: true , options: [{text:'Hot',value:'Hot'},{text:'Warm',value:'Warm'},{text:'Cold',value:'Cold'}]},
                { type: 'text-area', name: 'notes',label: "Notes", value: selectedLead.value?.notes || '', textarea_rows: '3', textarea_cols: '56', required: false },
                {  
                    type:'search-dropdown', label:"Lead Source", value: sourceValue.value, componentKey: currComponentKey,
                    selectOptions: sourceArray, optionSelected: handleSelectedSource, required: false,
                    searchPlaceholder: 'Select Source...', dropdownWidth: '350px', updateValue: selectedSource.value,
                    clearSearch: clearSelectedSource
                },
                {  
                    type:'search-dropdown', label:"Sales Rep", value: agentValue.value, componentKey: agentComponentKey,
                    selectOptions: agentArray, optionSelected: handleSelectedAgent, required: false,
                    searchPlaceholder: 'Select Rep...', dropdownWidth: '500px', updateValue: selectedRep.value,
                    clearSearch: clearSelectedAgent
                },
                {  
                    type:'search-dropdown', label:"Campaign Channel", value: channelValue.value, componentKey: chanComponentKey,
                    selectOptions: channelArray, optionSelected: handleSelectedChannel, required: false,
                    searchPlaceholder: 'Select Channel...', dropdownWidth: '350px', updateValue: selectedChannel.value,
                    clearSearch: clearSelectedChannel
                },
                {required: false}
            ];
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            formFields.value[8].value = 'New';
            formFields.value[9].value = 'Warm';
            agentComponentKey.value += 1;
            chanComponentKey.value += 1;
            currComponentKey.value += 1;
        }

        watch([selectedLead, selectedSource, selectedRep, selectedChannel], () => {
            if (selectedLead.value && selectedSource.value && selectedRep.value && selectedChannel.value) {
                updateFormFields();
                currComponentKey.value += 1;
                agentComponentKey.value += 1;
                chanComponentKey.value += 1;
            }
            else if(selectedLead.value && selectedSource.value && selectedRep.value ) {
                updateFormFields();
                currComponentKey.value += 1;
                agentComponentKey.value += 1;
            }
            else if (selectedLead.value && selectedSource.value && selectedChannel.value) {
                updateFormFields();
                currComponentKey.value += 1;
                chanComponentKey.value += 1;
            }
            else if(selectedLead.value && selectedRep.value && selectedChannel.value) {
                updateFormFields();
                agentComponentKey.value += 1;
                chanComponentKey.value += 1;
            }
            else if(selectedSource.value){
                updateFormFields();
                currComponentKey.value += 1;
            }
            else if(selectedRep.value){
                updateFormFields();
                agentComponentKey.value += 1;
            }
            else if(selectedChannel.value){
                updateFormFields();
                chanComponentKey.value += 1;
            }
            else if (selectedLead.value) {
                updateFormFields();
          
            }
            
        }, { immediate: true });
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createLead = async() =>{
            showModalLoader();
            let formData = {
                full_name: formFields.value[0].value,
                designation: formFields.value[3].value,
                town: formFields.value[6].value,
                country: formFields.value[7].value,
                email: formFields.value[2].value,
                phone_number: formFields.value[1].value,
                company_name: formFields.value[4].value,
                address: formFields.value[5].value,
                status: formFields.value[8].value,
                rating: formFields.value[9].value,
                notes: formFields.value[10].value,
                lead_source: sourceID.value,
                lead_source_id: sourceID.value,
                campaign_source: channelID.value,
                campaign_source_id: channelID.value,
                sales_rep: agentID.value,
                sales_rep_id: agentID.value,
                company: companyID.value
            }
  
            errors.value = [];
            for(let i=1; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Sales_Leads/createMarketingLead', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Lead created successfully!');
                        handleReset();
                    } else {
                        toast.error('An error occurred while creating the Lead.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Lead: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchLeads();
                }
            }
        }
        const updateLead = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                lead: selectedLead.value.lead_id,
                full_name: formFields.value[0].value,
                designation: formFields.value[3].value,
                town: formFields.value[6].value,
                country: formFields.value[7].value,
                email: formFields.value[2].value,
                phone_number: formFields.value[1].value,
                company_name: formFields.value[4].value,
                address: formFields.value[5].value,
                status: formFields.value[8].value,
                rating: formFields.value[9].value,
                notes: formFields.value[10].value,
                lead_source: sourceValue.value,
                lead_source_id: sourceValue.value,
                campaign_source: channelValue.value,
                campaign_source_id: channelValue.value,
                sales_rep: agentValue.value,
                sales_rep_id: agentValue.value,
                company: companyID.value
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Sales_Leads/updateMarketingLead', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        handleReset();
                        toast.success("Lead updated successfully!");              
                    } else {
                        toast.error('An error occurred while updating the Lead.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Lead: ' + error.message);
                } finally {
                    hideModalLoader();
                    propModalVisible.value = false;
                    await store.dispatch("Sales_Leads/updateState",{selectedLead:null,selectedSource:null,selectedRep:null,selectedChannel:null, isEditing:false})
                    searchLeads();
                }             
            }
        }
        const saveLead = () =>{
            if(isEditing.value == true){
                updateLead();
            }else{
                createLead();
            }
        }
        const importLeads = () =>{
            store.commit('pageTab/ADD_PAGE', {'CRM':'Import_Leads'})
            store.state.pageTab.crmActiveTab = 'Import_Leads';
        }
        const removeLead = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    lead: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Sales_Leads/deleteMarketingLead',formData)
                    if(response && response.status == 200){
                        toast.success("Lead Removed Succesfully");
                        searchLeads();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Lead: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Lead") 
            }else{
                toast.error("Please Select A Lead To Remove")
            }
        }
        const removeLeads = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    lead: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Sales_Leads/deleteMarketingLead',formData)
                    if(response && response.status == 200){
                        toast.success("Lead(s) Removed Succesfully");
                        searchLeads();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Lead: ' + error.message);
                }
                finally{
                    selectedIds.value = [];

                }
            }else{
                toast.error("Please Select A Lead To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchLeads = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                name: lead_name_search.value,
                phone_number: phone_number_search.value,
                email: email_search.value,
                rating: rating_search.value,
                status: status_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/marketing-leads-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                leadsList.value = response.data.results;
                store.commit('Sales_Leads/LIST_LEADS', leadsList.value)
                propResults.value = response.data;
                propArrLen.value = leadsList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchLeads(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            phone_number_search.value = "";
            lead_name_search.value = "";
            email_search.value = "";
            status_search.value = "";
            rating_search.value = "";
            searchLeads();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchLeads();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchLeads();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchLeads();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchLeads();
            // scrollToTop();
        }
        const formFields3 = ref([]);
        const updateFormFields3 = () => {
            formFields3.value = [
                { type: 'date', name: 'expected_close_date',label: "Expected Close Date", value: null, required: false },
                { type: 'number', name: 'value',label: "Estimated Value", value: 0, required: false },
                { type: 'number', name: 'probability',label: "Probability", value: 0, required: false },
                { type: 'text-area', name: 'notes',label: "Notes", value: '', textarea_rows: '3', textarea_cols: '56', required: false },
            ];
        };
        const handleReset3 = () =>{
            for(let i=0; i < formFields3.value.length; i++){
                formFields3.value[i].value = null;
            }
            formFields3.value[1].value = 0;
            formFields3.value[2].value = 0;
        }
        const showModalLoader3 = () =>{
            modal_loader3.value = "block";
        }
        const hideModalLoader3 = () =>{
            modal_loader3.value = "none";
        }
        const closeModal3 = () =>{
            propModalVisible.value = false;
            leadID.value = "";
            handleReset3();
        };
        const qualifyLead = async() =>{
            showModalLoader3();
            let formData = {
                lead: leadID.value,
                expected_close_date: formFields3.value[0].value || null,
                value: formFields3.value[1].value,
                probability: formFields3.value[2].value,
                notes: formFields3.value[3].value,
                company: companyID.value,
                user: userID.value
            }
  
            try {
                const response = await axios.post('api/v1/qualifying-marketing-lead/', formData);
                if (response && response.data.msg === "Success") {
                    hideModalLoader3();
                    toast.success('Lead qualified successfully!');
                    handleReset3();
                    propModalVisible.value = false;
                    searchLeads();
                } else {
                    toast.error('An error occurred while qualifying the Lead.');
                }
            } catch (error) {
                console.error(error.message);
                toast.error('Failed to qualify Lead: ' + error.message);
            } finally {
                hideModalLoader3();
            }
        }
        const addNewLead = async() =>{
            updateFormFields();
            await store.dispatch("Sales_Leads/updateState",{selectedLead:null,selectedSource:null,selectedChannel:null, selectedRep: null, isEditing:false})
            propModalVisible.value = true;
            handleReset();
            flex_basis.value = '1/4';
            flex_basis_percentage.value = '25';
            modal_width.value = '60vw';
            chanComponentKey.value += 1;
            agentComponentKey.value += 1;
            currComponentKey.value += 1;
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const leadID = row[idField];
                let formData = {
                    company: companyID.value,
                    lead: leadID
                }
                await store.dispatch('Sales_Leads/fetchMarketingLead',formData)
                propModalVisible.value = true;
                flex_basis.value = '1/4';
                flex_basis_percentage.value = '25';

            }else if(action == 'send-sms'){
                fetchTemplates();
                leadID.value = [row[idField]];
                transModalVisible.value = true;
                
            }else if(action == 'send-email'){
                fetchEmailTemplates();
                leadID.value = [row[idField]];
                emailModalVisible.value = true;
            }else if(action == "convert"){
                leadID.value = row[idField];   
                const leadStatus = row['status'];
                if(leadStatus == 'Converted' || leadStatus == 'Qualified'){
                    Swal.fire(`Lead Already ${leadStatus}!`, {
                        icon: "warning",
                    });
                    return;
                }
                if(leadStatus == 'Lost'){
                    Swal.fire("Cannot Qualify A Lost Lead!", {
                        icon: "warning",
                    });
                    return;
                }
                oppModalVisible.value = true;
                updateFormFields3();
                flex_basis.value = '1/2';
                flex_basis_percentage.value = '50';
                modal_width.value = '30vw';
            }else if(action == 'delete'){
                const leadID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    lead: leadID
                }
                await store.dispatch('Sales_Leads/deleteMarketingLead',formData).
                then(()=>{
                    searchLeads();
                })
            }
        }
        const closeModal = () =>{
            propModalVisible.value = false;
        };
        const printCustomersList = () =>{
            

        };
        const showModalLoader1 = () =>{
            modal_loader1.value = "block";
        }
        const hideModalLoader1 = () =>{
            modal_loader1.value = "none";
        }
        const handleReset1 = () =>{
            contentModel.value = "";
            leadID.value = "";
        };
        const fetchTemplates = async() =>{
            let formData = {
                company: companyID.value,         
            }

            await store.dispatch("Crm_SMS_Templates/fetchTemplates", formData)
        };
        const fetchEmailTemplates = async() =>{
            let formData = {
                company: companyID.value,         
            }

            await store.dispatch("Crm_Email_Templates/fetchTemplates", formData)
        };
        const handleSelectedTemplate = async(option) =>{
            await store.dispatch('Crm_SMS_Templates/handleSelectedTemplate', option)
            contentModel.value = store.state.Crm_SMS_Templates.templateContent;
        };
        const clearSelectedTemplate = async() =>{
            await store.dispatch('Crm_SMS_Templates/updateState', {templateID: '', templateName: "", templateContent: ""});
        }
        const sendClientSMS = async() =>{
            if(leadID.value && contentModel.value){
                showModalLoader1();
                let formData = {
                    content: contentModel.value,
                    client: leadID.value,
                    company: companyID.value
                }
                await axios.post('api/v1/leads-general-sms/',formData).
                then((response)=>{
                    if(response.data.msg == "Success"){
                        toast.success("SMS Sent!")
                        closeModal1();
                        searchLeads();
                    }else{
                        toast.error(response.data.msg)
                    }
                })
                .catch((error)=>{
                    toast.error(error.message)
                })
                .finally(()=>{
                    hideModalLoader1();
                })
            }else if(leadID.value == ""){
                toast.error("No Lead Selected!!")
            }else if(contentModel.value == ""){
                toast.error("Cannot Send Blank SMS!!")
            }
            
        };
        const handleSelectedEmailTemplate = async(option) =>{
            await store.dispatch('Crm_Email_Templates/handleSelectedTemplate', option)
            emailTempID.value = store.state.Crm_Email_Templates.templateID;
        };
        const clearSelectedEmailTemplate = async() =>{
            await store.dispatch('Crm_Email_Templates/updateState', {templateID: '', templateName: "", templateContent: ""});
            emailTempID.value = '';
        }
        const sendClientEmail = async() =>{
            showModalLoader1();
            let formData = {
                template: emailTempID.value,
                lead: leadID.value,
                company: companyID.value
            }
            await axios.post('api/v1/leads-general-email/',formData).
            then((response)=>{
                if(response.data.msg == "Success"){
                    toast.success("Email Sent!")
                    closeModal1();
                    searchLeads();
                }else{
                    toast.error(response.data.msg)
                }
            })
            .catch((error)=>{
                toast.error(error.message)
            })
            .finally(()=>{
                hideModalLoader1();
            })
            
        };
        const dropdownOptions = ref([
            {label: 'SMS Selected Lead', action: 'send-sms', icon: 'fa-sms', colorClass: 'text-blue-600', rightName: 'Sending CRM SMS'},
            {label: 'Email Selected Lead', action: 'send-email', icon: 'fa-envelope', colorClass: 'text-indigo-600', rightName: 'Sending CRM Emails'},
        ]);
        const handleDynamicOption = async(option) =>{
            if(option == 'send-sms'){
                if(selectedIds.value.length == 0){
                    toast.error("Please Select A Lead To Send SMS")
                    return;
                }
                fetchTemplates();
                leadID.value = selectedIds.value;
                transModalVisible.value = true;
                
            }else if(option == 'send-email'){
                if(selectedIds.value.length == 0){
                    toast.error("Please Select A Lead To Send Email")
                    return;
                }
                fetchEmailTemplates();
                leadID.value = selectedIds.value;
                emailModalVisible.value = true;
            }
        };
        const closeModal1 = async() =>{
            transModalVisible.value = false;
            emailModalVisible.value = false;
            handleReset1();
        }
        onBeforeMount(()=>{
            searchLeads();
            fetchLeadSources();
            fetchSalesAgents();
            fetchCampaignChannels();
        })
        return{
            title, searchLeads,resetFilters, addButtonLabel, searchFilters, tableColumns, leadsList,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,dropdownOptions,handleDynamicOption,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, addNewLead, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, saveLead, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            importLeads, removeLead, removeLeads, handleReset,printCustomersList,addingRight,removingRight,rightsModule,selectSearchQuantity,selectedValue,
            messageContent,modal_loader1,title1,showModalLoader1,hideModalLoader1,sendClientSMS,transModalVisible,emailModalVisible,title2,
            closeModal1,contentModel,textareaRef,leadPlaceholders,selectedPlaceholder,insertPlaceholder,templateArr,dropdownWidth,
            handleSelectedTemplate,clearSelectedTemplate,handleSelectedEmailTemplate,clearSelectedEmailTemplate,emailTempArr,sendClientEmail,
            formFields3, handleReset3, showModalLoader3, hideModalLoader3, qualifyLead,oppModalVisible, title3,modal_loader3,closeModal3
        }
    }
};
</script>